import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { signInWithShareCode, signOut } from '../../../core/actions';

import {
  getProjectByShareCode,
  getNoteByShareCode,
  getHighlightReelByShareCode,
  getReportByShareCode,
} from './graphql';

import PasswordDialog from './components/password-dialog';

const SharedProject = (props) => {
  const {
    onSignIn,
    onSignOut,
    match: {
      params: {
        shareCode,
        shareType,
      },
    },
    history,
  } = props;

  const [loading, setLoading] = useState(true);
  const [passwordError, setPasswordError] = useState();

  const handleSignIn = useCallback(async (password) => {
    try {
      await onSignIn(shareType, shareCode, password);
    } catch (ex) {
      if (ex.code === 'authentication_error') {
        setLoading(false);
        if (password) {
          setPasswordError('Invalid password');
        }
      } else {
        history.push('/');
      }
      return;
    }
    try {
      if (shareType === 'project') {
        const { project } = await getProjectByShareCode(shareCode);
        history.push(`/projects/${project.id}/study`);
      } else if (shareType === 'clip') {
        const { testSessionNote } = await getNoteByShareCode(shareCode);
        history.push(`/clips/${testSessionNote.id}`);
      } else if (shareType === 'highlight-reel') {
        const { highlightReel } = await getHighlightReelByShareCode(shareCode);
        history.push(`/highlight-reel/${highlightReel.id}`);
      } else if (shareType === 'report') {
        const { report } = await getReportByShareCode(shareCode);
        history.push(`/report/${report.id}`);
      }
    } catch (ex) {
      onSignOut();
      history.push('/');
    }
  }, [onSignIn, onSignOut, shareCode, history]);

  useEffect(() => {
    handleSignIn();
  }, [handleSignIn]);

  return (
    <PasswordDialog
      loading={loading}
      error={passwordError}
      onSubmit={handleSignIn}
    />
  );
};

SharedProject.propTypes = {
  onSignIn: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      shareCode: PropTypes.string,
      shareType: PropTypes.string,
    }),
  }).isRequired,
};

const mapDispatchToProps = {
  onSignIn: signInWithShareCode,
  onSignOut: signOut,
};

export default connect(null, mapDispatchToProps)(SharedProject);
